/// <reference path="../app.ts" />

namespace Cfnc {
    "use strict"

    interface ICareerDetails {
    }


    class CareerDetails implements ICareerDetails {
        static $inject: Array<string> = ["common", "Restangular", "$routeParams", "$q", "$uibModal", "$window", "config", "$interval"];
        static controllerId: string = "careerDetails";
        private log;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;
        urlName: string;
        occupation: IOccupation;
        crossIndustryUSWages: IUSWages;
        crossIndustryNCWages: INCWages;
        majors: IMajor[];
        institutions: IInstitution[];
        ncMSAWages: any;
        loading: boolean = true;
        salaryGuage: any;
        salaryBellcurve: any;
        educationPiechart: any;
        jobsPer1000: number;

        interval: any;
        time: number;
       


        constructor(private common: ICommonFactory, private Restangular: Restangular.IService, private $routeParams: ng.route.IRouteParamsService, private $q: ng.IQService, private $uibModal: angular.ui.bootstrap.IModalService, private $window: ng.IWindowService, private config: IConfig, private $interval: ng.IIntervalService) {
            this.log = common.logger.getLogFn(CareerDetails.controllerId);
            this.logError = common.logger.getLogFn(CareerDetails.controllerId, "error");
            this.logSuccess = common.logger.getLogFn(CareerDetails.controllerId, "success");
            this.urlName = $routeParams.occupation;
            this.activate();

           
        }

        activate() {
            var promises = [this.getOccupation()];
            this.common.activateController(promises, CareerDetails.controllerId)
                .then(() => {
                    this.time = 10;
                    this.interval = this.$interval(() => {
                        this.time -= 1;
                        if (this.time <= 0) {
                            this.$interval.cancel(this.interval);
                            this.$window.location.href = this.config.ncCareersUrl + "/cfncredirect?q=" + encodeURIComponent("/occupation-profile/" + this.occupation.occCode.replace("-", "").substring(0, 6) + "/1284");
                        }
                    }, 1000)
                    this.loading = false;
                });
        }

        getOccupation(): ng.IPromise<void> {
            return this.Restangular.all("careers").all("occupations").one(this.urlName).get()
                .then((result) => {
                    this.occupation = result;
                  
                },
                    (reason) => {
                        console.log(reason);
                    });
        }

        getUSWageData(): ng.IPromise<void> {
            return this.Restangular.oneUrl("uswages", this.occupation.usWageDataUrl).get({ naics: "000000" })
                .then((result) => {
                    if (result.totalCount > 0) {
                        this.crossIndustryUSWages = result.results[0];
                        this.salaryGuage.series[0].data = this.crossIndustryUSWages.annualMeanWage ? [this.crossIndustryUSWages.annualMeanWage] : null;

                    }
                }, (reason) => {
                    console.log(reason);
                });
        }

        getNCWageData(): ng.IPromise<void> {
            var defer = this.$q.defer<void>();

            var ncwages = this.Restangular.oneUrl("ncwages", this.occupation.ncWageDataUrl).get()
                .then((result): INCWages => {
                    if (result.totalCount > 0) {
                        return result.results[0];
                    }
                });

            var uswages = this.Restangular.oneUrl("uswages", this.occupation.stateWageDataUrl).get()
                .then((result): IUSWages => {
                    if (result.totalCount > 0) {
                        return result.results[0];

                    }
                });

            var ncmsawages = this.Restangular.oneUrl("ncmsawages", this.occupation.ncWageDataUrl).get({ areaType: "NCMSA" });

            this.$q.all<INCWages, IUSWages, any>([ncwages, uswages, ncmsawages]).then((values) => {
                this.crossIndustryNCWages = values[0];
                this.jobsPer1000 = values[1].jobsPer1000;

                this.salaryBellcurve.series[0].name = "Annual Salary";
                this.salaryBellcurve.series[0].data = [];

                if (values[1].annual10thPercentileWage) {
                    this.salaryBellcurve.series[0].data.push([10, values[1].annual10thPercentileWage]);
                }

                if (values[1].annual25thPercentileWage) {
                    this.salaryBellcurve.series[0].data.push([25, values[1].annual25thPercentileWage]);
                }

                if (values[1].annualMedianWage){
                    this.salaryBellcurve.series[0].data.push([50, values[1].annualMedianWage]);
                }

                if (values[1].annual75thPercentileWage) {
                    this.salaryBellcurve.series[0].data.push([75, values[1].annual75thPercentileWage]);
                }

                if (values[1].annual90thPercentileWage) {
                    this.salaryBellcurve.series[0].data.push([90, values[1].annual90thPercentileWage]);
                }

                this.salaryBellcurve.series[0].data.unshift([0, null]);
                this.salaryBellcurve.series[0].data.push([100, null]);

                this.ncMSAWages = _.filter(values[2].results, (x) => { return [37000056, 37000091, 37000041, 37000142, 37000003].indexOf(x.areaId) > -1 });

                defer.resolve();
            }, (reason) => {
                console.log(reason);
            });

            return defer.promise;
        }

        getSchoolsAndPrograms(): ng.IPromise<void> {
            return this.Restangular.oneUrl("schoolsandprograms", this.occupation.programsAndMajorsUrl).get()
                .then((result) => {
                    this.majors = result.majors;
                    this.institutions = result.institutions;
                }, (reason) => {
                    console.log(reason);
                });
        }

        saveCareer() {
            sessionStorage.setItem("careers.command", "save");
            this.common.authentication.authenticate(true).then(() => {
                sessionStorage.removeItem("careers.command");
                if (!this.occupation.isSaved) {
                    var modalInstance = this.$uibModal.open({
                        templateUrl: "/app/common/confirmationModal.html",
                        controller: "confirmationModal",
                        resolve: {
                            data: {
                                title: "Save Career",
                                content: `Are you sure you want to add ${this.occupation.occTitle} to your list of Saved Careers?`
                            }
                        }
                    });

                    modalInstance.result.then(result => {
                        if (result) {
                            this.Restangular.all("careers/savedcareers").post({ OCCCode: this.occupation.occCode }).then(() => {
                                this.occupation.isSaved = true;
                                this.logSuccess("Saved successfully to your Saved Careers", "Saved successfully to your Saved Colleges.", true);
                            }, (reason) => {
                                this.logError(reason, reason, true);
                            });
                        }
                    });
                } else {
                    var modalInstance = this.$uibModal.open({
                        templateUrl: '/app/common/confirmationModal.html',
                        controller: 'confirmationModal',
                        resolve: {
                            data: {
                                title: "Remove Saved College",
                                content: `Are you sure you wish to remove ${this.occupation.occTitle} from your Saved Careers?`
                            }
                        }
                    });
                    modalInstance.result.then((result) => {
                        if (result) {
                            this.Restangular.one("careers/savedcareers").remove({ occCode: this.occupation.occCode }).then((results) => {
                                this.occupation.isSaved = false;
                                this.logSuccess("Successuflly removed from your Saved Colleges.", null, true);
                            }, (reason) => {
                                    this.logError(reason, reason, true);
                            });
                        }
                    });
                }

            });
        }


        get guageOptions() {
            return {
                title: {
                    text: null
                },
                chart: {
                    height: 200,
                    
                    type: 'solidgauge',
                },
                pane: {
                    center: ['50%','90%'],//['50%', '90%'],
                    size: '175%',
                    startAngle: -90,
                    endAngle: 90,
                    background: {
                        backgroundColor: '#EEE',
                        innerRadius: '60%',
                        outerRadius: '100%',
                        shape: 'arc'
                    }
                },
                tooltip: {
                    enabled: false
                },
                yAxis: {
                    stops: [
                        [0, '#36845b'], // green
                    ],
                    lineWidth: 0,
                    minorTickInterval: null,
                    tickAmount: 2,
                    title: {
                        y: -70,
                    },
                    labels: {
                        y: 16
                    }
                },
                plotOptions: {
                    solidgauge: {
                        dataLabels: {
                            y: 5,
                            borderWidth: 0,
                            useHTML: false,
                            format:
                                '<div style="text-align:center">' +
                                '<span style="font-size:25px">${y:,.0f}</span><br/>' +
                                '</div>',
                        },
                        tooltip: {
                            valuePrefix: '$'
                        }
                    },
                },
                credits: {
                    enabled: false
                },
                series: [{
                    id: "series-0",
                    data: []
                }]
            };
        }


        get bellcurveOptions() {
            return {
                title: {
                    text: null
                },
                chart: {
                    height: 300
                },
                yAxis: [{
                    id: 'y-axis',
                    title: {
                        text: null
                    }
                }, {
                    id: 'y-axis2',
                    visible: false
                }],
                xAxis: [{
                    id: 'x-axis',
                    title: {
                        text: 'Percentile'
                    },
                    alignTicks: false
                }, {
                    id: 'x-axis2',
                    visible: false
                }],
                series: [{
                    id: "series-0",
                    type: 'line',
                    color: '#b1e460',

                    lineWidth: 4,
                    accessibility: {
                        exposeAsGroupOnly: true
                    },
                    marker: {
                        radius: 7
                    },
                    tooltip: {
                        valuePrefix: '$',
                        headerFormat: '<span style="font-size: 10px">{point.key}%</span><br/>'
                    },
                    data: []
                },
                {
                    id: "series-1",
                    name: 'Percentile',
                    type: 'bellcurve',
                    xAxis: 'x-axis2',
                    yAxis: 'y-axis2',
                    baseSeries: "series-0",
                    zIndex: -1,
                    color: '#154b40',
                    enableMouseTracking: false

                }]
            };
        }

        get piechartOptions() {
            return {
                chart: {
                    type: 'pie'
                },
                title: {
                    text: 'Level of Education'
                },
                subtitle: {
                    text: null
                },
                plotOptions: {
                    series: {
                        dataLabels: {
                            enabled: false,
                            format: '{point.name}: {point.y:.1f}%'
                        },
                        showInLegend: true,
                    }
                },
                tooltip: {
                    headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                    pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>'
                },
                legend: {
                    labelFormatter: function () {
                        var i = this.name.indexOf(" - ");
                        if (i > 0) {
                            return this.name.substring(0, i);
                        }

                        return this.name;
                    }
                },
                series: [
                    {
                        name: "Education Levels",
                        colorByPoint: true,
                        data: []
                    }
                ]

            };
        }


    }
    angular.module("app").controller(CareerDetails.controllerId, CareerDetails);
} 